import { render } from "./stub.vue?vue&type=template&id=620fa130"
import script from "./stub.vue?vue&type=script&lang=js"
export * from "./stub.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./style.less?vue&type=style&index=0&module=true&lang=css&external"
cssModules["$style"] = style0
import "./pricing.less?vue&type=style&index=1&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__